var _excluded = ["right", "left"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useState, useEffect, useRef } from 'react';
import classes from './myAccountMenu.css';
import help from '@magento/venia-ui/venia-static/icons/helpcontact.svg';
import wishlist from '@magento/venia-ui/venia-static/icons/wishlist.svg';
import orders from '@magento/venia-ui/venia-static/icons/orders.svg';
import account from '@magento/venia-ui/venia-static/icons/account.svg';
import ArrowIcon from '@magento/venia-ui/venia-static/icons/arrow.svg';
import { useWindowSize } from '@magento/peregrine';
import { useHistory } from '@magento/venia-drivers';
import { FormattedMessage, useIntl } from 'react-intl';
import StoreSwitcher from './storeSwitcher';
import parse_html from '@magento/pagebuilder/lib/helper';
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { useMutation } from '@apollo/client';
import { useAwaitQuery } from '@magento/peregrine/lib/hooks/useAwaitQuery';
import { CREATE_CART } from '@magento/peregrine/lib/talons/SignIn/signIn.gql';
import { GET_CART_DETAILS_QUERY } from '../SignIn/signIn.gql';
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { ChevronRight, X } from "react-feather";
import Icon from "../Icon";
import BBLink from "../BBLink";
var MyAccountMenu = props => {
  var {
    accountMenu,
    setAccountMenu,
    menuHeaderData,
    accountMode,
    isPrerender,
    menuData
  } = props;
  var history = useHistory();
  var menuRef = useRef();
  var [fetchCartId] = useMutation(CREATE_CART);
  var fetchCartDetails = useAwaitQuery(GET_CART_DETAILS_QUERY);
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var [{
    userData,
    currentUser,
    isSignedIn
  }, {
    signOut
  }] = useUserContext();
  var [, {
    setOpenStoreModal
  }] = useAppContext();
  var user = userData || currentUser;
  var [backHeaderMenu, setBackHeaderMenu] = useState([]);
  var [backMenu, setBackMenu] = useState([menuHeaderData]);
  var [accountOpen, setAccountOpen] = useState(isPrerender);
  var [index, setIndex] = useState(0);
  var {
    formatMessage
  } = useIntl();
  var STATIC_NAME = user && user.firstname ? " ".concat(user.firstname) : "";
  var windowSize = useWindowSize();
  var isMobile = windowSize.innerWidth <= 1248;
  var STATIC_STRINGS = {
    account: formatMessage({
      defaultMessage: 'Account',
      id: 'Account'
    }),
    signIn: formatMessage({
      defaultMessage: 'Sign in',
      id: 'accountTrigger.signIn'
    }),
    signOut: formatMessage({
      defaultMessage: 'Sign out',
      id: 'accountMenu.signOutButtonText'
    }),
    helloName: "Hello".concat(STATIC_NAME, "!"),
    back: formatMessage({
      defaultMessage: 'Back',
      id: 'Back'
    }),
    myInformation: formatMessage({
      defaultMessage: 'My Information',
      id: 'myInformation'
    }),
    myOrders: formatMessage({
      defaultMessage: 'My Orders',
      id: 'myOrders'
    }),
    myWishlist: formatMessage({
      defaultMessage: 'My Wishlist',
      id: 'myWishlist'
    }),
    customerService: formatMessage({
      defaultMessage: 'Customer Service',
      id: 'customerService'
    })
  };
  var accountOptions = [{
    icon: account,
    label: STATIC_STRINGS.myInformation,
    url: '/my-account'
  }, {
    icon: orders,
    label: STATIC_STRINGS.myOrders,
    url: '/order-history'
  }, {
    icon: wishlist,
    label: STATIC_STRINGS.myWishlist,
    url: '/wishlist'
  }, {
    icon: help,
    label: STATIC_STRINGS.customerService,
    url: currentStoreCode === 'en' ? '/privacy-and-security' : '/politique-vie-privee'
  }];
  var backButtonSection = _ref => {
    var {
      label,
      onClick
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.optionHeader,
      onClick: () => {
        onClick();
        scrollTopMenu();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.sectionHeaderName
    }, /*#__PURE__*/React.createElement("p", null, label)), /*#__PURE__*/React.createElement("div", {
      className: classes.backButton
    }, /*#__PURE__*/React.createElement("img", {
      src: ArrowIcon,
      className: classes.backArrow,
      alt: 'arrowIcon'
    }), STATIC_STRINGS.back));
  };
  useEffect(() => {
    if (isMobile && accountMenu === 'closeAccountMenu') {
      setAccountOpen(false);
      setIndex(0);
      setBackHeaderMenu([]);
    }
  }, [accountMenu, isMobile]);
  var accountMenuAccount = /*#__PURE__*/React.createElement(React.Fragment, null, isPrerender ? menuData && menuData.storeMenuByIdentifier && menuData.storeMenuByIdentifier.items && menuData.storeMenuByIdentifier.items[0] && menuData.storeMenuByIdentifier.items[0].nodes && menuData.storeMenuByIdentifier.items[0].nodes.map(item => {
    return /*#__PURE__*/React.createElement(BBLink, {
      to: '/' + item.url_path
    }, item.name);
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.accountMenuAccount
  }, isMobile && backButtonSection({
    label: STATIC_STRINGS.account,
    onClick: () => setAccountOpen(!accountOpen)
  }), accountOptions.map((o, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classes.menuOption
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: o.url,
    className: classes.accountOptionName,
    onClick: () => setAccountMenu('closeAccountMenu')
  }, !isMobile && /*#__PURE__*/React.createElement("img", {
    src: o.icon,
    height: 20,
    width: 20,
    alt: o.label
  }), /*#__PURE__*/React.createElement("span", null, o.label)))), isMobile && /*#__PURE__*/React.createElement("button", {
    className: classes.redButton,
    onClick: /*#__PURE__*/_asyncToGenerator(function* () {
      setAccountMenu('closeAccountMenu');
      yield signOut({
        fetchCartId,
        fetchCartDetails
      });
    })
  }, STATIC_STRINGS.signOut)));
  var scrollTopMenu = () => {
    menuRef && menuRef.current && menuRef.current.scroll({
      top: 0,
      behavior: 'smooth'
    });
  };
  var menuMobile = /*#__PURE__*/React.createElement("div", {
    className: accountOpen ? classes.menuMobileItemsOpen : classes.menuMobileItems
  }, /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    className: backHeaderMenu.length > 0 ? classes.menuBack : classes.menu
  }, isMobile && !accountMode && backMenu && backMenu[index] && backMenu[index].sort((a, b) => a.position - b.position).map((item, count) => {
    var {
        right,
        left
      } = item,
      rest = _objectWithoutProperties(item, _excluded);
    var hasInnerItems = right.length > 0 || left.length > 0;
    return /*#__PURE__*/React.createElement("button", {
      key: "backMenu-".concat(count),
      className: "".concat(hasInnerItems ? classes.menuOption : classes.specificOption),
      onClick: () => {
        if (right.length > 0) {
          setBackMenu([...backMenu, right]);
          setBackHeaderMenu([...backHeaderMenu, rest]);
          setIndex(index + 1);
        } else if (left.length > 0) {
          setBackMenu([...backMenu, left]);
          setBackHeaderMenu([...backHeaderMenu, rest]);
          setIndex(index + 1);
        } else {
          var path = item.url_path;
          setAccountMenu('closeAccountMenu');
          if (item.url_path.includes('http')) {
            window.open(item.url_path, '_blank');
          } else {
            history.push("/".concat(path));
          }
          setBackMenu([menuHeaderData]);
        }
        scrollTopMenu();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: item.classes ? classes[item.classes] : ''
    }, /*#__PURE__*/React.createElement("p", {
      className: classes.optionName
    }, parse_html(item.name))), hasInnerItems && /*#__PURE__*/React.createElement(Icon, {
      src: ChevronRight
    }));
  }), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: classes.storeOptionsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.menuOption
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.myAccountMobile,
    onClick: () => {
      if (isSignedIn) {
        setAccountOpen(!accountOpen);
        setIndex(0);
        setBackHeaderMenu([]);
      } else {
        setAccountMenu('closeAccountMenu');
        history.push("/sign-in");
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: account,
    height: 30,
    width: 30,
    alt: 'account'
  }), /*#__PURE__*/React.createElement("span", null, isSignedIn ? STATIC_STRINGS.account : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'accountTrigger.signIn',
    defaultMessage: 'Sign In'
  }))), isSignedIn && /*#__PURE__*/React.createElement(Icon, {
    src: ChevronRight
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.menuOption
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: "/".concat(formatMessage({
      id: 'header.contactus',
      defaultMessage: 'contact-us'
    })),
    onClick: () => setAccountMenu('closeAccountMenu')
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.help',
    defaultMessage: 'Help'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.menuOption
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: isSignedIn ? "/".concat(formatMessage({
      id: 'header.orderHistory',
      defaultMessage: 'order-history'
    })) : "/".concat(formatMessage({
      id: 'header.signin',
      defaultMessage: 'sign-in'
    })),
    onClick: () => setAccountMenu('closeAccountMenu')
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.trackOrder',
    defaultMessage: 'Track Your Order'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.menuOption,
    onClick: () => {
      setOpenStoreModal(true);
      setAccountMenu('closeAccountMenu');
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.stores',
    defaultMessage: 'Stores'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.menuOption
  }, /*#__PURE__*/React.createElement(StoreSwitcher, {
    opposite: true,
    fullLang: true
  }))) : null), isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, accountMenuAccount));
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.myAccountMenu, " ").concat(classes[accountMenu], " ").concat(isPrerender ? classes.prerenderHidden : null)
  }, !isMobile && /*#__PURE__*/React.createElement("button", {
    className: classes.user,
    onClick: () => {
      setAccountMenu('closeAccountMenu');
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'checkout.helloUser',
    defaultMessage: 'Hello, {firstname}',
    values: {
      firstname: STATIC_NAME
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    src: X,
    size: '2rem'
  })), !accountMode && backHeaderMenu.length > 0 && isMobile && backButtonSection({
    label: backHeaderMenu.length > 0 ? parse_html(backHeaderMenu[index - 1].name) : STATIC_STRINGS.back,
    onClick: () => {
      var newBackHeaderMenu = backHeaderMenu.slice(0, backHeaderMenu.length - 1);
      var newBackMenu = backMenu.slice(0, backMenu.length - 1);
      setBackMenu(newBackMenu);
      setBackHeaderMenu(newBackHeaderMenu);
      setIndex(index - 1);
    }
  }), menuMobile, (accountMode || !isMobile) && /*#__PURE__*/React.createElement(React.Fragment, null, accountMenuAccount), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: classes.optionSignOutContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.redButton,
    onClick: /*#__PURE__*/_asyncToGenerator(function* () {
      return isSignedIn ? yield signOut({
        fetchCartId,
        fetchCartDetails
      }) : history.push('/sign-in');
    })
  }, isSignedIn ? STATIC_STRINGS.signOut : STATIC_STRINGS.signIn)));
};
export default MyAccountMenu;